import { gql } from "@apollo/client";

const ActiveUserMutation = gql`
  mutation ActiveUser($userId: UUID!, $active: Boolean!) {
    updateUserByAppId(
      input: { userPatch: { isActive: $active }, appId: $userId }
    ) {
      user {
        isActive
      }
    }
  }
`;

const hash = "952f749bd60050c2c16dfa7ed8e32a3e701d3ecc67a451e9f1bbe8c9fee462af";

export { ActiveUserMutation, hash };
